export const INSIGHT_CATEGORIES = [
  ['', 'All'],
  ['ai-orchestration', 'AI &amp; Orchestration'],
  ['property-tax-operations', 'Property Tax Operations'],
  ['enterprise-ai', 'Enterprise AI'],
  ['product-updates', 'Product Updates'],
  ['case-studies', 'Case Studies'],
  ['company-news', 'Company News'],
] as const;

/** A category slug; the empty string means "All". */
export type InsightCategory = (typeof INSIGHT_CATEGORIES)[number][0];

export const isInsightCategory = (value: unknown): value is InsightCategory =>
  INSIGHT_CATEGORIES.some(([slug]) => slug === value);

export const categoryLabel = (category: string): string =>
  INSIGHT_CATEGORIES.find(([slug]) => slug === category)?.[1] ?? '';
